import React from "react";

interface AccordionItemProps {
  id: number;
  title: string;
  content: string;
  isOpen: boolean;
  onToggle: (id: number) => void;
}

const FAQCard: React.FC<AccordionItemProps> = ({
  id,
  title,
  content,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="border rounded-[7px] border-[#F2F2F2] bg-[#FBFBFB] w-full">
      <button
        onClick={() => onToggle(id)}
        className="w-full text-left px-6 py-5  focus:outline-none flex items-center justify-between gap-8"
      >
        <div className="flex items-center justify-start gap-8">
          <div className="faq__id w-[3rem]">{id}</div>
          <div className="faq__title font-medium">{title}</div>
        </div>

        {isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M0.153898 13.154L6.90421 6.40371L13.6498 13.1493L13.6509 6.85199L6.89949 0.100627L0.157821 6.8423L0.153898 13.154Z"
              fill="#12213B"
              fill-opacity="0.2"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M13.6449 0.745638L6.89462 7.49595L0.149023 0.750351L0.147975 7.04767L6.89933 13.799L13.641 7.05736L13.6449 0.745638Z"
              fill="#35BCAB"
            />
          </svg>
        )}
      </button>
      {isOpen && (
        <div className="faq__text px-[6.5rem] max-[899px]:ps-[5.7rem] max-[899px]:pe-[3rem] py-2 bg-gray-50">
          <p>{content}</p>
        </div>
      )}
    </div>
  );
};

export default FAQCard;
